import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as image from "../../resources/images";
import { ShimmerSimpleGallery } from "react-shimmer-effects";
import { applyDiscount } from "../../redux/actions/APIs";
import { billingPlan } from "../../redux/actions";

const PricingPlan = ({setSelectedPlan, selectedPlan, hanldeStep, planDataArr, planType, setPlanType})=>{
    const dispatch = useDispatch();

    const choosePackage = (planObj)=>{
        hanldeStep(2, true);
        if(selectedPlan?.id !== planObj?.id){
            setSelectedPlan({...planObj});
            dispatch(applyDiscount());
            // dispatch(billingPlan());
        } 
    } 
    return(
        <>
            {planDataArr?.length > 0 ? (
                <div className="pricingcardlist text-center">
              <h1>Pricing Plans</h1>
              <div class="chooseSubscription">
                <div class="form-check form-switch d-flex justify-content-center text-center p-0 subscriptionChoose mb-4 pb-3">
                  <label class="form-check-label d-flex w-90 m-auto p-0 justify-content-center" 
                    htmlfor="flexSwitchCheckDefault">
                    <h2>
                      <span className={`${planType === "monthly" && "subsActive"}`}>Monthly</span>
                      <span class={`position-relative ${planType === "yearly" && "subsActive"}`}>Annually 
                        <span class="saveuptomsg">Save 17% per year</span></span>
                    </h2>
                    <input 
                        class="form-check-input pointer"
                        type="radio"
                        id="planType"
                        onClick={()=>setPlanType(planType === "yearly" ? "monthly" : "yearly")}
                        checked={planType === "yearly"}
                      
                    />
                  </label>

                </div>
              </div>
              <div className="text-center flexfive">
                {planDataArr?.map((data, index)=>(
                    planType === data?.type && (
                        <div className={`pricing_card ${selectedPlan?.id === data?.id && "activePricing"}`} key={index}>
                            <h3>{data?.name}</h3>
                            <h2>${data?.amount}</h2>
                            <h4>{planType === "monthly" ? "Per Month" : "Per Year" }</h4>
                            <ul>
                                <li><img src={image.checkcutted} />14-day free trial</li>
                                <li><img src={image.checkcutted} />Unlimited access to all content</li>
                                {(data?.androidId === "singlechild" || data?.androidId === "singlechild-y") ? (
                                    <li><img src={image.checkcutted} />Access for one child</li>
                                ) : (
                                    <li><img src={image.checkcutted} />No limit on the number of children</li>
                                )} 
                            </ul>
                            <p onClick={()=>choosePackage(data)}>
                                <a href="javascript:void(0)">Choose Plan</a>
                            </p>
                        </div>
                    )
                   
                ))}
              </div>
            </div>
            ) : (
                <ShimmerSimpleGallery card imageHeight={300} caption />
            )}
        </>
        
    );
}
export default PricingPlan;